
export const initialUserAddressError = {
    _id: "",
    title: "",
    fullName: "",
    country: "",
    province: "",
    city: "",
    address: "",
    building: "",
    apartment: "",
    phoneNumber: "",
    alternativePhoneNumber: "",
    description: "",
    longitude: "",
    latitude: "",
    governorateId: "",
    districtId: "",
    subDistrictId: "",
    cityId: "",
    governorateCode: "",
    districtCode: "",
    subDistrictCode: "",
    cityCode: "",
    postalCode: "",
    neighborhood: "",
    mahallah: "",
    landmark: "",
    street: "",
    buildingNumber: "",
    floorNumber: "",
    apartmentNumber: "",
    premise: "",
    email: "",
    deliveryNotes: "",
    partnerGovernorateCode: "",
};

export type InitialUserAddressError = typeof initialUserAddressError;

export const initialUserAddress = {
    _id: "",
    title: "",
    fullName: "",
    country: "Iraq",
    province: "",
    city: "",
    address: "",
    building: "",
    apartment: "",
    phoneNumber: "",
    alternativePhoneNumber: "",
    description: "",
    longitude: 0.0,
    latitude: 0.0,
    governorateId: "",
    districtId: "",
    subDistrictId: "",
    cityId: "",
    governorateCode: "",
    districtCode: "",
    subDistrictCode: "",
    cityCode: "",
    postalCode: "",
    neighborhood: { main: "", en: "", kr: "" },
    mahallah: { main: "", en: "", kr: "" },
    landmark: { main: "", en: "", kr: "" },
    street: { main: "", en: "", kr: "" },
    buildingNumber: "",
    floorNumber: "",
    apartmentNumber: "",
    premise: "",
    email: "",
    deliveryNotes: "",
    partnerGovernorateCode: "",
}

export type InitialUserAddress = typeof initialUserAddress;
